<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="580" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="primary--text text-uppercase font-weight-bold">Nilai Produk</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pt-1 pb-0">
					<v-row v-for="i in 2" :key="i">
						<v-col cols="4" md="2" class="py-1">
							<v-card outlined class="rounded-lg">
								<v-col class="my-auto pa-1">
									<v-img width="100%" height="60" class="rounded-lg" src="/assets/product/swiss-clock.png"></v-img>
								</v-col>
							</v-card>
						</v-col>
						<v-col cols="8" md="10" class="pl-0 my-auto">
							<div class="text-body-2">Swiss Clock</div>
						</v-col>
					</v-row>
					<v-row align="center" justify="center">
						<v-col cols="9" md="5" class="">
							<star-rating :border-width="3" border-color="#d8d8d8" :star-size="30" rounded-corners :increment="0.5" v-model="rating"></star-rating>
						</v-col>
					</v-row>
					<v-row>
						<v-col class="px-3 pt-1 d-flex flex-wrap justify-center">
							<div>
								<v-chip class="ma-1 rounded-lg text-body-2" color="primary" outlined>
									Kualitas produk sangat baik.
								</v-chip>
							</div>
							<div>
								<v-chip class="ma-1 rounded-lg text-body-2" color="grey darken-2" outlined>
									Produk original.
								</v-chip>
							</div>
							<div>
								<v-chip class="ma-1 rounded-lg text-body-2" color="grey darken-2" outlined>
									Harga produk murah.
								</v-chip>
							</div>
							<div>
								<v-chip class="ma-1 rounded-lg text-body-2" color="grey darken-2" outlined>
									Kecepatan pengiriman sangat baik.
								</v-chip>
							</div>
							<div>
								<v-chip class="ma-1 rounded-lg text-body-2" color="grey darken-2" outlined>
									Respon penjual sangat baik.
								</v-chip>
							</div>
						</v-col>
					</v-row>
					<v-row align="center" justify="center">
						<v-col cols="12" class="pt-1">
							<div>
								<div class="text-body-2 text-md-body-1 font-weight-bold pb-1">Pendapat Anda tentang produk ini</div>
								<v-textarea single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-resize height="100"></v-textarea>
							</div>
							<div class="pt-1 d-flex">
								<v-icon color="pink" small>mdi-alert-circle-outline</v-icon>
								<div class="pt-1 pl-3 pl-md-1 pink--text text-caption">Anda hanya dapat mengedit penilaian terhadap toko 1 kali saja.</div>
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" class="text-center">
							<v-btn depressed color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg">Simpan</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
	components: {
		StarRating
	},
	data () {
		return {
			dialog: false,
			rating: 0,
		}
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	},
};
</script>